import React, { useState } from 'react';
import { useRouter } from 'next/router';
import { useRecoilValue } from 'recoil';
import TableTemplate from '@/components/Common/Table/TableTemplate';
import TableRow from '@/components/Common/Table/TableRow';
import TabMenu from '@/components/Common/Tab/TabMenu';
import TableCount from '@/components/Common/Table/TableCount';
import TableSearch from '@/components/Common/Table/TableSearch';
import TablePagination from '@/components/Common/Table/TablePagination';
import CommunityTableBody from '@/components/Community/CommunityTableBody';

import Button, {
  ButtonSize,
  ButtonRadius,
  ButtonVariant,
} from '@/components/Common/Button';

import {
  FooterSearchLayout,
  FooterButtonLayout,
} from '@/components/Common/Table/Table.styled';
import { loginState } from '@/stores/auth';

export enum SearchType {
  Title = 'title',
  User = 'username',
}

export enum TabMenuIndex {
  All,
  Notice,
  Free,
  League,
}

interface CommunityComponentProp {
  posts: any;
  pathname: any;
  query: any;
}

function CommunityComponent({
  posts,
  pathname,
  query,
}: CommunityComponentProp) {
  const isLogin = useRecoilValue(loginState);
  const router = useRouter();
  const [selectedValue, setSelectedValue] = useState<SearchType>(
    SearchType.User
  );
  const [searchKeyword, setSearchKeyword] = useState<string>('');
  const { to, total, current_page, per_page } = posts.data.posts;

  // query search button event
  const handleSearch = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const params = {
      [selectedValue]: searchKeyword,
    };
    router.push({
      pathname: `/community/${pathname}`,
      query: {
        ...params,
      },
    });
  };

  // query search input event
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    setSearchKeyword(inputValue);
  };

  const selectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { value } = e.target;
    setSelectedValue(value as SearchType);
  };

  return (
    <>
      <TabMenu pathname={pathname} tabs={TAB_MENUS} />
      <TableTemplate
        colgroup={COLGROUP}
        Column={<TableRow columns={SIMULATION_COLUMNS} />}
        Body={<CommunityTableBody rows={posts.data.posts} />}
        Footer={
          <>
            <FooterButtonLayout>
              <TableCount totalCount={total} presentCount={to} />
              {query?.type === 'free' && isLogin && (
                <Button
                  type="button"
                  width={250}
                  height={56}
                  size={ButtonSize.Big}
                  radius={ButtonRadius.Oval}
                  variant={ButtonVariant.Default}
                  label="등록하기"
                  onClick={() => {
                    router.push(`/community/free/create`);
                  }}
                />
              )}
            </FooterButtonLayout>
            <FooterSearchLayout>
              <TableSearch
                options={SELECT_OPTIONS}
                selectedValue={selectedValue}
                selectChange={selectChange}
                handleSubmit={handleSearch}
                inputValue={searchKeyword}
                handleInputChange={handleInputChange}
              />
            </FooterSearchLayout>
            <TablePagination
              page={current_page}
              perPage={per_page}
              count={total}
              query={query}
              redirectPath={`/${pathname}`}
            />
          </>
        }
      />
    </>
  );
}

export default CommunityComponent;

const SIMULATION_COLUMNS = [
  '구분',
  'No.',
  '제목',
  '작성자',
  '조회수',
  '생성일시',
];

const SELECT_OPTIONS = [
  {
    value: SearchType.Title,
    text: '제목',
  },
  {
    value: SearchType.User,
    text: '작성자',
  },
];

const TAB_MENUS = [
  {
    id: TabMenuIndex.All,
    text: '전체',
    path: '/community',
  },
  {
    id: TabMenuIndex.Notice,
    text: '공지사항',
    path: '/community/notice',
  },
  {
    id: TabMenuIndex.Free,
    text: '자유게시판',
    path: '/community/free',
  },
  {
    id: TabMenuIndex.League,
    text: '대회정보',
    path: '/community/event',
  },
];

const COLGROUP = [
  { id: 1, col: '10%' },
  { id: 2, col: '10%' },
  { id: 3, col: '30%' },
  { id: 4, col: '22%' },
  { id: 5, col: '10%' },
  { id: 6, col: '18%' },
];
